
<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="2">
            <v-text-field
              label="Nome"
              v-model="form.filters.nome"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              label="CPF"
              v-model="form.filters.cpf"
              v-mask="'###.###.###-##'"
              maxlength="14"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <sca-select-ativo
            :cols="2"
            :config="{
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo',
              label: 'Situação',
            }"
            v-model="form.filters.situacao"
          ></sca-select-ativo>
          <v-col cols="2">
            <v-select
              label="Lotação"
              v-model="form.filters.lotacao"
              outlined
              dense
              :items="form.lists.listLotacoes"
              item-text="nome"
              item-value="codigoMunicipio"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="2">
            <v-select
              label="Função"
              v-model="form.filters.funcao"
              outlined
              dense
              :items="form.lists.listFuncoes"
              item-text="nome"
              item-value="id"
            ></v-select>
          </v-col>
          <sca-date-picker
            :cols="2"
            label="Data Início"
            v-model="form.filters.dataInicial"
            removeIcon
            outlined
            dense
            ></sca-date-picker>
          <sca-date-picker
            :cols="2"
            label="Data Final"
            v-model="form.filters.dataFinal"
            removeIcon
            outlined
            dense
          ></sca-date-picker>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarRelatorios()"
            ></sca-tooltip>
            <sca-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5 printable"
        :headers="headers"
        :items="form.lists.listRelatorios"
        :items-per-page="10"
        :footer-props="$footerProps"
        :sort-desc="true"
      >
        <template v-slot:[`item.nome`]="{ item }">
          {{ item.nome }}
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.dataAcao`]="{ item }">
          {{ $formatarDataHora(item.dataAcao) }}
        </template>
        <template v-slot:[`item.acao`]="{ item }">
          {{ item.acao }}
        </template>
      </v-data-table>
      <sca-buttons
        v-if="form.lists.listRelatorios.length"
        actionText="Baixar PDF"
        cancelText="Baixar CSV"
        @click="baixarRelatorio('PDF')"
        @cancel="baixarRelatorio('CSV')"
      ></sca-buttons>
    </v-container>
  </div>
</template>

<script>
import RelatorioLogProfissionalService from "~/services/relatorios-log/manter-profissional-log.service";
import PreLoginService from "~/services/pre-login.service";
import DataTableMixin from "~/mixins/datatables.mixin";
import FormatoArquivoEnum from "~/commons/enums/formato-arquivo.enum";

export default {
  name: "RelatorioLogSolicitacoesAcesso",
  mixins: [
    RelatorioLogProfissionalService,
    PreLoginService,
    DataTableMixin
  ],
  data: () => ({
    form: {
      filters: {
        nome: null,
        cpf: null,
        lotacao: null,
        funcao: null,
        situacao: null,
        dataInicial: null,
        dataFinal: null,
      },
      lists: {
        listRelatorios: [],
        listLotacoes: [],
        listFuncoes: [],
      }
    },
    headers: [
      { text: "Nome", align: "center", value: "nome" },
      { text: "CPF", align: "center", value: "cpf" },
      { text: "Lotação", align: "center", value: "lotacao.nome" },
      { text: "Função", align: "center", value: "funcao.nome" },
      { text: "Situação", align: "center", value: "ativo" },
      { text: "Data/Hora da ação", align: "center", value: "dataAcao" },
      { text: "Ação", align: "center", value: "acao" },
    ]
  }),
  methods: {
    async buscarRelatorios() {
      if (this.validarDatas() && this.verificarFiltrosPreenchidos()) {
        const { data } = await this.$obterRelatorioLogProfissional({ params: this.form.filters });
        this.form.lists.listRelatorios = data.lista;
      }
    },
    validarDatas() {
      const { dataInicial, dataFinal } = this.form.filters;
      if (dataInicial && dataFinal) {
        if (new Date(dataFinal) < new Date(dataInicial)) {
          return this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
        }
      }
      return true;
    },
    verificarFiltrosPreenchidos() {
      const { dataInicial, dataFinal, situacao, nome, cpf, lotacao, funcao } = this.form.filters;
      if (situacao == null && !dataInicial && !dataFinal && !nome && !cpf && !lotacao && !funcao) {
        return this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
      }
      return true;
    },
    async baixarRelatorio(formato) {
      switch (formato) {
        case FormatoArquivoEnum.CSV:
          return this.baixarRelatorioCSV();
        case FormatoArquivoEnum.PDF:
          return this.baixarRelatorioPDF();
        default:
          return this.$notifyWarning("Formato de relatório inválido.");
      }
    },
    async baixarRelatorioCSV() {
      const { data } = await this.$obterRelatorioLogCSVProfissional({ params: this.form.filters });
      this.$baixarRelatorioCSV(data, `SCA.${this.$options.name}${FormatoArquivoEnum.CSV}`, "Operação realizada com sucesso.");
    },
    async baixarRelatorioPDF() {
      const { data } = await this.$obterRelatorioLogPDFProfissional({ params: this.form.filters });
      this.$baixarRelatorioPDF(data, `SCA.${this.$options.name}${FormatoArquivoEnum.PDF}`, "Operação realizada com sucesso.");
    },
    buscarLotacoes() {
      this.$obterLotacoes().then(({ data }) => this.form.lists.listLotacoes = data.lista);
    },
    buscarFuncoes() {
      this.$obterFuncoes().then(({ data }) => this.form.lists.listFuncoes = data.lista);
    },
    resetForm() {
      this.$clearFilters(this.form.filters);
      this.form.lists.listRelatorios = [];
    }
  },
  mounted() {
    this.buscarLotacoes();
    this.buscarFuncoes();
  }
};
</script>
